import React from 'react';
import styled from 'styled-components';
import {Drop_USP} from '../../../../grpc_client/grips/protos/shared/drop';
import {useMedia} from '../../../../utils/hooks/useMedia';
import {ShareButton} from '../../../ShareButton/ShareButton';
import {mediaMinDesktop} from '../../../constants/customMedia';
import {Headline, HeadlineContainer, Subline} from '../DropOverviewStyles';
import Pill from '../Pill/Pill';

const TeaserArea = styled.div<{backgroundImage: string}>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(${props => props.backgroundImage});
  position: relative;
`;

const Gradient = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  background-image: linear-gradient(#000, rgba(0, 0, 0, 0.3) 0%);
  top: 0;
`;

const StyledPill = styled(Pill)<{isStickyTop: boolean}>`
  margin-top: ${props => (props.isStickyTop ? 0 : '46px')};
`;

const USPContainer = styled.div`
  position: absolute;
  bottom: 16px;
  left: 16px;
  text-align: center;
`;

const TextOverlay = styled.div`
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.1),
    rgba(0, 0, 0, 0) 100%
  );
  height: 100vh;
  width: 100vw;
  background-size: 800px 100%;
  background-position: 50% 100%;
  grid-column: 1;
  grid-row: 1 / span 3;

  @media ${mediaMinDesktop} {
    width: 713px;
    height: 639px;
  }
`;
interface Props {
  backgroundImageUrl: string;
  countdownText?: string;
  className?: string;
  isPillStickyTop?: boolean;
  smallPill?: boolean;
  usps?: Drop_USP[];
  onClick?: () => void;
  subline?: string;
  headline?: string;
  shareUrl?: string;
}

export const DropTeaserArea: React.FC<Props> = ({
  backgroundImageUrl,
  subline,
  headline,
  countdownText,
  className,
  isPillStickyTop = false,
  onClick,
  smallPill = false,
  usps,
  shareUrl,
}) => {
  const isDesktop = useMedia(
    {
      [mediaMinDesktop]: true,
    },
    false,
  );
  return (
    <TeaserArea
      onClick={onClick}
      backgroundImage={backgroundImageUrl}
      className={className}
    >
      <Gradient />
      {countdownText && (
        <StyledPill
          smallPill={smallPill}
          type="main"
          isStickyTop={!isDesktop || isPillStickyTop}
        >
          {countdownText}
        </StyledPill>
      )}

      {headline && (
        <>
          {backgroundImageUrl.length > 0 && <TextOverlay />}
          <HeadlineContainer backgroundImageUrl={backgroundImageUrl}>
            {subline && <Subline>{subline}</Subline>}

            <Headline>{headline}</Headline>
          </HeadlineContainer>
        </>
      )}

      {shareUrl && <ShareButton shareUrl={shareUrl} />}

      {usps && usps.length > 0 && (
        <USPContainer>
          {usps.map(({text}) => (
            <Pill key={text} type="usp">
              {text}
            </Pill>
          ))}
        </USPContainer>
      )}
    </TeaserArea>
  );
};
